import styles from "./HText.module.css";

type HTextProps = {
  text: string;
};

export const HText = ({ text }: HTextProps) => (
  <div className={styles.text}>{text}</div>
);
